import { render, staticRenderFns } from "./upModel.vue?vue&type=template&id=250a8000&scoped=true&"
import script from "./upModel.vue?vue&type=script&lang=js&"
export * from "./upModel.vue?vue&type=script&lang=js&"
import style0 from "./upModel.vue?vue&type=style&index=0&lang=scss&scope=true&"
import style1 from "./upModel.vue?vue&type=style&index=1&id=250a8000&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250a8000",
  null
  
)

export default component.exports